export default {
  SET_FIX_CLIENTS: function (state, payloads) {
    state.fixClients = payloads;
  }
}
